import { render, staticRenderFns } from "./TablePaginatorView.vue?vue&type=template&id=2c6f62e5"
import script from "./TablePaginatorView.vue?vue&type=script&lang=js"
export * from "./TablePaginatorView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports